import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ProductGrid from '@/components/sections/ProductGrid';

export default function ProductsIndex() {
  return (
    <main className="min-h-screen bg-background">
      <Header variant="solid" />
      <div className="pt-32 pb-10">
        <div className="container mx-auto">
          <div className="font-script text-2xl text-leaf">the full line</div>
          <h1 className="font-display text-5xl sm:text-6xl text-primary font-medium leading-tight mt-1 max-w-3xl">
            Eight sell sheets.<br/>
            <span className="italic font-light">One trusted bakery.</span>
          </h1>
          <p className="text-muted-foreground max-w-xl mt-4">
            Tap any product for the full sell sheet — macros, allergens, MOQ, MSRP and bake-off card.
          </p>
        </div>
      </div>
      <ProductGrid />
      <Footer />
    </main>
  );
}
